
import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';
import {LessonRecord} from '../student-program';

@Component({
	props: ['rec'],
})
export default class LessonTile extends Vue {
	get toLink() {
		if (this.$route.params.lessonId) {
			return {
				name: 'courseLessonNav',
				params:{
					'courseId': this.$route.params.courseId,
				}
			};
		} else {

			return {
				name: 'courseLessonNav',
				params: {
					'courseId': this.$route.params.courseId,
					'lessonId': this.rec.lessonId,
				}
			}

		}
	}

}
